<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { bindTipSoundUnlock } from '@/utils/tipSound'

export default {
  name: 'App',
  mounted() {
    // 解锁提示音自动播放（需用户至少点击一次页面）
    bindTipSoundUnlock()
    // 已登录则建立全局 WebSocket（对齐小程序 onLaunch）
    if (this.$store.getters.token) {
      this.$store.dispatch('websocket/connectAppWebSocket').catch(() => {})
    }
  }
}
</script>
